import moment from "moment";
import numeral from "numeral";
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/pl";
import "moment/locale/pt-br";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import "moment/locale/ja";
import "moment/locale/it";
import "numeral/locales/de";
import "numeral/locales/es";
import "numeral/locales/fr";
import "numeral/locales/pl";
import "numeral/locales/pt-br";
import "numeral/locales/chs";
import "numeral/locales/ja";
import "numeral/locales/it";
import { changeLanguage } from "i18n";
import Store from "logic/local-storage/Store";
import { DEFAULT_LANGUAGE } from "components/users/languages/Languages";
const LAST_LANGUAGE_KEY = "language";
const NUMERAL_LOCALES = { "pt-BR": "pt-br", "zh-CN": "chs" };
export const lastLanguage = () => {
  var _a;
  return (_a = Store.get(LAST_LANGUAGE_KEY)) != null ? _a : DEFAULT_LANGUAGE;
};
const applyLanguage = async (language) => {
  var _a;
  await changeLanguage(language);
  moment.locale(language);
  const numeralLocale = (_a = NUMERAL_LOCALES[language]) != null ? _a : language;
  numeral.locale(numeral.locales[numeralLocale] ? numeralLocale : DEFAULT_LANGUAGE);
  Store.set(LAST_LANGUAGE_KEY, language);
};
export default applyLanguage;
